export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  PROJECT_ADMIN = 'PROJECT_ADMIN'
}

export interface ClientAccess {
  [clientId: string]: {
    role: string;
  };
}

export interface ProjectAccess {
  [projectId: string]: {
    role: string;
  };
}

export interface User {
  uid: string;
  email: string | null;
  displayName?: string | null;
  photoURL?: string | null;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  companyRole?: string;
  role?: UserRole;
  clientId?: string;
  organizationId?: string;
  projectAccess?: ProjectAccess;
  clientAccess?: ClientAccess;
  createdAt?: Date;
  updatedAt?: Date;
}
